<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-popup   :title="$t('skillDetails.action2.a3')" :active.sync="CancelEmail" >
      <div class="con-exemple-prompt">
        <div class="con-exemple-prompt">
          {{FeedbackData}}
          {{$t('skillDetails.action2.a5')}}  <b>{{FeedbackData.inviteeEmail}}</b> ?
        </div>
        <vs-button
          class="ml-4 mt-4 float-right"
          @click="confirmCancelEmail(FeedbackData)"
        >{{$t('skillDetails.action2.a7')}}</vs-button>
      </div>
    </vs-popup>
    <vs-popup   :title="$t('skillDetails.action2.a17')" :active.sync="ExtendEmail" >
      <div class="con-exemple-prompt">
        <div class="con-exemple-prompt">
          {{$t('skillDetails.action2.a18')}}  <b>{{FeedbackData.inviteeEmail}}</b> ?
        </div>
        <vs-button
          class="ml-4 mt-4 float-right"
          @click="confirmExtendEmail(FeedbackData)"
        >{{$t('skillDetails.action2.a7')}}</vs-button>
      </div>
    </vs-popup> <vs-popup   :title="$t('skillDetails.action2.a20')" :active.sync="confirmScheduleEmail" >
    <div class="con-exemple-prompt">
      <div class="con-exemple-prompt">
        {{$t('skillDetails.action2.a19')}} <b>{{FeedbackData.inviteeEmail}}</b> ?
      </div>
      <vs-button
        class="ml-4 mt-4 float-right"
        @click="confirmresetScheduleEmail(FeedbackData)"
      >{{$t('skillDetails.action2.a7')}}</vs-button>
    </div>
  </vs-popup>
    <vs-table>
      <template slot="thead">
        <!--        {{products}}-->
        <vs-th sort-key="inviteeEmail">{{$t('tblHeadings.th3')}}</vs-th>
        <vs-th sort-key="inviteUserName">{{$t('tblHeadings.th4')}}</vs-th>
        <vs-th sort-key="skillCount" class="text-primary">{{$t('tblHeadings.th5')}}</vs-th>
        <!--        <vs-th sort-key="Monitoring">Competency</vs-th>-->
        <!--        <vs-th sort-key="Feedback11">Action</vs-th>-->

      </template>
      <!--{{products[0].inviteeEmail}}-->
      <template >
        <vs-tr  @click="CompetenciesFeedback(inviteeData)" v-for="(inviteeData, index) in inviteeData" :key="index" >
          <vs-td >
            {{ index }}
          </vs-td>
          <vs-td >
            {{inviteeData[0].inviteUserName}}
          </vs-td >
          <vs-td  >
            <b style="color:#9DCD5B;">{{inviteeData.length}}</b>
          </vs-td>
          <!--            <vs-td v-for="(allcompentency, index) in inviteeData" :key="index">-->
          <!--              {{ allcompentency.traineeCompetenciesId}}-->
          <!--             </vs-td>-->
          <template class="expand-user" slot="expand">
            <div id="data-list-list-view1" class="data-list-container" style="width:100%">
              <!--&lt;!&ndash;            <template slot="thead">&ndash;&gt;-->
              <!--&lt;!&ndash;              <vs-th sort-key="id">{{ $t("coach.traineeList.tl1") }}</vs-th>&ndash;&gt;-->
              <!--&lt;!&ndash;              <vs-th sort-key="name">Rater Name </vs-th>&ndash;&gt;-->
              <!--&lt;!&ndash;              <vs-th sort-key="skillCount">Competency</vs-th>&ndash;&gt;-->
              <!--&lt;!&ndash;              &lt;!&ndash;        <vs-th sort-key="Monitoring">Feedback Status</vs-th>&ndash;&gt;&ndash;&gt;-->
              <!--&lt;!&ndash;              <vs-th sort-key="Feedback11">Action</vs-th>&ndash;&gt;-->
              <!--&lt;!&ndash;              <vs-th></vs-th>&ndash;&gt;-->
              <!--            </template>-->
              <vs-table  >
                <template slot="thead">
                  <vs-th >{{$t('tblHeadings.th20')}}</vs-th>
                  <vs-th > </vs-th>
                  <vs-th ></vs-th>
                  <!--        <vs-th sort-key="Monitoring">Feedback Status</vs-th>-->
                </template>

                <template  >
                  <!--          {{data}}-->
                  <tbody>
                  <!--                      {{inviteeData}}-->
                  <vs-tr   v-for="(allcompentency, index) in inviteeData" :key="index">
                    <vs-td>
                      <p class="product-name font-medium truncate">{{allcompentency['endorsementInvitePrgms'][0].progressMeasureId}}</p>
                    </vs-td>
                    <vs-td v-for="(externalFeedback, index) in allcompentency['endorsementInvitePrgms'][0].externalFeedback" :key="index" >

                      <feather-icon v-if="(new Date(externalFeedback.feedbackSentDate)) <(new Date()) &&  externalFeedback.emailStatus===0" icon="CircleIcon"  title="Feedback not received, Followup required" :svgClasses="['fill-current h-4 w-4', 'text-warning']" />
                      <feather-icon v-else-if="externalFeedback.currentGap >0 && externalFeedback.emailStatus===1" icon="CircleIcon"  title="Feedback received" :svgClasses="['fill-current h-4 w-4', 'text-primary']" />
                      <feather-icon v-else-if="externalFeedback.currentGap===0 && externalFeedback.emailStatus===1" icon="CircleIcon"  title="Feedback received" :svgClasses="['fill-current h-4 w-4', 'text-primary']" />
                      <feather-icon v-else-if="externalFeedback.emailStatus===4" icon="CircleIcon"  title="Feedback received" :svgClasses="['fill-current h-4 w-4', 'text-primary']" />
                      <feather-icon v-else-if="externalFeedback.currentGap === 0 && externalFeedback.emailStatus===5" icon="CircleIcon"  title="Gap closed" :svgClasses="['fill-current h-4 w-4', 'text-success']" />
                      <feather-icon v-else-if=" externalFeedback.emailStatus===6" icon="CircleIcon"  title="Goal Completed" :svgClasses="['fill-current h-4 w-4', 'text-success']" />
                      <feather-icon v-else-if="(new Date(externalFeedback.feedbackSentDate)) >(new Date()) && externalFeedback.emailStatus===0" icon="CircleIcon"  title="Email Scheduled" :svgClasses="['fill-current h-4 w-4', 'text-grey']" />
                      <feather-icon v-else-if="externalFeedback.emailStatus===1" icon="CircleIcon"  title="Email schedule canceled" :svgClasses="['fill-current h-4 w-4', 'text-grey']" />
                      <feather-icon v-else-if="externalFeedback.emailStatus===2" icon="CircleIcon"  title="Followup sent" :svgClasses="['fill-current h-4 w-4', 'text-danger']" />
                    </vs-td>
                    <vs-td >
                      <!--<feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />-->
                      <!--                          <vs-button  :disabled="allcompentency['endorsementInvitePrgms'][0].extendEmailDisable" @click="extendEmail(allcompentency)">{{$t('Extend')}}</vs-button>-->
                      <!--                          <vs-button  :disabled="true" @click="extendEmail(allcompentency)">{{$t('Extend')}}</vs-button>-->
                      <!--                          <vs-button  line-origin="left" color="success" class="mt-2 ml-2" v-show="allcompentency['endorsementInvitePrgms'][0].cancel"  @click="cancelEmail(allcompentency)">{{$t('Cancel')}}</vs-button>-->
                      <!--                          <vs-button  line-origin="left" color="success" class="mt-2 ml-2" v-show="allcompentency['endorsementInvitePrgms'][0].Schedule"  @click="ScheduleEmail(allcompentency)">{{$t('Schedule')}}</vs-button>-->
                    </vs-td>
                  </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </template>
        </vs-tr>
      </template>

    </vs-table>
  </div>
</template>
<script>
import i18n from "@/i18n/i18n";
  export default {
    data () {
      return {
        selected: [],
        inviteeData:[],
        itemsPerPage: 100,
        CancelEmail:false,
        ExtendEmail:false,
        confirmScheduleEmail:false,
        extendEmailDisable:true,
        Schedule:false,
        CCD: this.$t("addNewSkill.data"),
        cancel:false,
        traineeName:'',
        FeedbackData:[],
        external_tokens:[]
      }
    },
    computed: {
      // currentPage () {
      //   if (this.isMounted) {
      //     return this.$refs.table.currentx
      //   }
      //   return 0
      // },
      products(){
        return this.inviteeData
      },
      // queriedItems () {
      //   return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
      // },

    },

    // methods: {
    //   CompetenciesFeedback(data){
    //    console.log(data);
    //   }},
    created(){
  //    const usersId = 133;
       let userId = url.searchParams.get("userId");
      if(userId){
        userId = url.searchParams.get("userId");
        this.$vs.notify({
          title: i18n.t('notification.user.traineeList.rater.r1'),
          fixed: true,
          color:'success'
        });
      }else{
        userId= this.$store.state.AppActiveUser.usersId;
      }

      const query={query:{
          id:usersId
        }}
      this.$store
        .dispatch("users/find", query)
        .then(res => {
          this.traineeName=res.data[0].firstName+' '+res.data[0].lastName
          //     console.log(traineeName);
        }).catch(err => {
        console.log("error users not found ", err);
      });

      this.$store.dispatch('addSkill/findCompetency', {query: {usersId: usersId}})
        .then(res => {
          console.log("all Skills", res.data);
          let id = [];
          for (let i = 0; i < res.data.length; i++) {
            id.push(res.data[i].id);
          }
          console.log('traineeCompetenciesId',id);
          this.$store.dispatch('endorsement-invite/find', {query: {traineeCompetenciesId:{ $in:id}}})
            .then(res => {
              console.log("all invitee data", res.data);
              for(let i=0;i<res.data.length;i++){
                // console.log(res.data.length)
                // //  console.log('ss',)
                this.$store.dispatch('external-feedback/find', {query: {endorsement_invite_prgms_id: res.data[i]['endorsementInvitePrgms'][0].id}})
                  .then(res1 => {
                    //let externalFeedbackLates=res1.data;
                    res.data[i]['endorsementInvitePrgms'][0].externalFeedback=res1.data;
                  }).catch({});
                let count=0;
                let extendEmail=0;
                let completeCount=0;
                let feedbackLength=res.data[i]['endorsementInvitePrgms'][0].externalFeedback.length;
                for(let j=0;j<res.data[i]['endorsementInvitePrgms'][0].externalFeedback.length;j++) {
                  // if ((res.data[i]['endorsementInvitePrgms'][0].externalFeedback[j].emailStatus === 1) && (res.data[i]['endorsementInvitePrgms'][0].externalFeedback[j].feedbackSentDate >(new Date())) && (res.data[i]['endorsementInvitePrgms'][0].externalFeedback[j].currentGap ===null)) {
                  //   count = count + 1;
                  // }
                  // else if((res.data[i]['endorsementInvitePrgms'][0].externalFeedback[j].feedbackSentDate >(new Date())) && (res.data[i]['endorsementInvitePrgms'][0].externalFeedback[j].currentGap >=0)){
                  //   completeCount=completeCount+1;
                  // }
                }
                console.log('completeCount',completeCount);
                if(res.data[i]['endorsementInvitePrgms'][0]['progressMeasureId'].length<=12) {
                  const characteristicId = res.data[i]['endorsementInvitePrgms'][0]['progressMeasureId'].split("-")[0];
                  const competencyId = res.data[i]['endorsementInvitePrgms'][0]['progressMeasureId'].split("-")[1];
                  console.log(characteristicId, competencyId);
                  const competencies = this.CCD[characteristicId].competencies;
//                                console.log(competencies);
                  const currentCompetency = competencies[competencyId];
                  console.log(currentCompetency);
                  //this.currentCompetency = currentCompetency;
                  res.data[i]['endorsementInvitePrgms'][0]['progressMeasureId'] = currentCompetency.comp;
                }else{
                  this.$store.dispatch('trainee-competencies-prgms/find', {query: {progressMeasureId:res.data[i]['endorsementInvitePrgms'][0]['progressMeasureId']}})
                    .then(res1 => {
                      console.log('trainee-competencies-prgms',
                        res1.data);
                      this.$store.dispatch('trainee-competencies/find', {query: {id:res1.data[0]['traineeCompetenciesId']}})
                        .then(res2 => {
                          console.log('trainee-competencies',
                            res2.data);
                           console.log('dadasd',res2.data[0]['competencyId']);

                          const characteristicId =res2.data[0]['competencyId'].split("-")[0];

                          const competencies = this.CCD[characteristicId].competencies;
//
                          const currentCompetency = competencies[0];
                          console.log('competencies data',competencies);
                          //this.currentCompetency = currentCompetency;
                          res.data[i]['endorsementInvitePrgms'][0]['progressMeasureId'] = currentCompetency.comp;
                          });
                     });
                }
                // console.log('skill name',this.InviteSkillName);
                console.log('Cancel Count Data',count);
                // if(count>=1){
                //    res.data[i]['endorsementInvitePrgms'][0]['cancel']=false;
                //    res.data[i]['endorsementInvitePrgms'][0]['Schedule']=true;
                // }else if(completeCount===6){
                //   res.data[i]['endorsementInvitePrgms'][0]['cancel']=false;
                //   res.data[i]['endorsementInvitePrgms'][0]['Schedule']=false;
                // }
                // else{
                //   res.data[i]['endorsementInvitePrgms'][0]['cancel']=true;
                //   res.data[i]['endorsementInvitePrgms'][0]['Schedule']=false;
                // }
                console.log('data',res.data[i]);
                //if(extendEmail===1){
                //    res.data[i]['endorsementInvitePrgms'][0]['extendEmailDisable']=false;
                //  }else{
                //    res.data[i]['endorsementInvitePrgms'][0]['extendEmailDisable']=true;
                //  }
              }
              function groupBy(array, key){
                const result = {}
                array.forEach(item => {
                  if (!result[item[key]]){
                    result[item[key]] = []
                  }
                  result[item[key]].push(item)
                })
                return result
              }
              this.inviteeData=groupBy(res.data, 'inviteeEmail');
            })
            .catch(err => {})
        })
        .catch(err => {})
    },
    methods:{
      extendEmail(data){
        this.ExtendEmail=true;
        this.FeedbackData=data
      },
      confirmExtendEmail(data){
        console.log('dsfafdad',data);
        let dateDifference;
        for(let i=0;i<data['endorsementInvitePrgms'][0].externalFeedback.length;i++){
          let firstDate = new Date(data['endorsementInvitePrgms'][0].externalFeedback[0].feedbackSentDate)
          let lastDate = new Date(data['endorsementInvitePrgms'][0].externalFeedback[1].feedbackSentDate)
          dateDifference =getDifferenceInDays(lastDate, firstDate);
          function getDifferenceInDays(date1, date2) {
            const diffInMs = Math.abs(date2 - date1);
            return diffInMs / (1000 * 60 * 60 * 24);
          }
        }

        for(let k=1;k<=2;k++) {
          const uuid4 = require("uuid4");
          console.log(uuid4());
          console.log(this.traineeName);
          console.log(data['endorsementInvitePrgms'][0]['progressMeasureId']);
          console.log(data['endorsementInvitePrgms'][0]['externalFeedback'][0]['endorsementInvitePrgmsId']);
          console.log(data['endorsementInvitePrgms'][0]['externalFeedback'][5]['feedbackSentDate']);
          console.log(new Date(new Date(data['endorsementInvitePrgms'][0]['externalFeedback'][5]['feedbackSentDate']).setDate(new Date(data['endorsementInvitePrgms'][0]['externalFeedback'][5]['feedbackSentDate']).getDate() + dateDifference)))
          const extFeedObj = {
            traineeName: this.traineeName,
            mailType: "followup",
            inviteeEmail: data.inviteeEmail,
            inviteUserName: data.inviteUserName,
            skillName: data['endorsementInvitePrgms'][0]['progressMeasureId'],
            endorsementInvitePrgmsId: data['endorsementInvitePrgms'][0]['externalFeedback'][0]['endorsementInvitePrgmsId'],
            trainingDuration: new Date(new Date(data['endorsementInvitePrgms'][0]['externalFeedback'][5]['feedbackSentDate']).setDate(new Date(data['endorsementInvitePrgms'][0]['externalFeedback'][5]['feedbackSentDate']).getDate() + dateDifference * 2)),
            externalToken: uuid4(),
            lang: ((window.$cookies.get('locale') == 'es') ? 'es' : 'en'),
            externalTokenExpired: false,
            feedbackSentDate: new Date(new Date(data['endorsementInvitePrgms'][0]['externalFeedback'][5]['feedbackSentDate']).setDate(new Date(data['endorsementInvitePrgms'][0]['externalFeedback'][5]['feedbackSentDate']).getDate() + dateDifference * k)),
            emailStatus: 0
          };
          this.$store
            .dispatch("endorsementInvite/pushExternalFeedback", extFeedObj)
            .then(res => {
            }).catch(err => {
            console.log("error  in extend external feedback", err);
          });
          // let   query1={query:{id:11}}
          //   this.$store
          //     .dispatch("endorsementInvite/pushExternalFeedback", extFeedObj)
          //     .then(res => {}).catch(err => {
          //     console.log("error  in extend external feedback", err);
          //   });
          //   console.log(extFeedObj);
          // }
        }
        console.log(dateDifference);
      },
      cancelEmail(data){
        console.log('Feedback Email Data',data);
        this.FeedbackData=data
        this.CancelEmail=true;

      },
      confirmCancelEmail(data){
        console.log('sdasdasid',data);
        let deletedexternalToken = [];
        let emailStatusCount=0;

        for (var i=0;i<data['endorsementInvitePrgms'][0].externalFeedback.length;i++) {
          // console.log((new Date(data[i].feedbackSentDate)));
          if((new Date(data['endorsementInvitePrgms'][0].externalFeedback[i].feedbackSentDate)) > (new Date())) {
            deletedexternalToken.push(data['endorsementInvitePrgms'][0].externalFeedback[i].externalToken);
            if(data['endorsementInvitePrgms'][0].externalFeedback[i].emailStatus===1) {
              emailStatusCount = emailStatusCount + 1;
            }
          }
        }
        console.log('External Token',deletedexternalToken);
        if(deletedexternalToken.length!==0) {
          const query = {query: {externalToken: deletedexternalToken}}

          this.$store
            .dispatch("invitee-message-id/find", query)
            .then(res => {
              const gapFeedObj = {
                flag: 'cancel',
                feedbackId:data['endorsementInvitePrgms'][0].externalFeedback[0].id,
                messageId: res.data
              }
              this.$store
                .dispatch("external-feedback/patch", [data['endorsementInvitePrgms'][0].externalFeedback[0].id, gapFeedObj])
                .then(res1 => {
                  console.log("external feedback patched", res1);
                  this.$store
                    .dispatch("external-feedback/find", {
                      query: {
                        endorsementInvitePrgmsId:data['endorsementInvitePrgms'][0].externalFeedback[0].endorsementInvitePrgmsId,
                        currentGap: null,
                      }
                    })

                    .then(res2 => {
                      console.log("external feedback patched", res2);
                      if (emailStatusCount!== 0) {
                        this.$vs.notify({
                          color: "primary",
                          title: i18n.t('notification.user.traineeList.emailSchedule.cancelSchedule.warning.c1'),
                          text:  i18n.t('notification.user.traineeList.emailSchedule.cancelSchedule.warning.c2')
                        });
                      } else {
                        this.$vs.notify({
                          color: "primary",
                          title: i18n.t('notification.user.traineeList.emailSchedule.cancelSchedule.success.c1'),
                          text:  i18n.t('notification.user.traineeList.emailSchedule.cancelSchedule.success.c2')
                        });
                      }
                      console.log(res2.data);
                      for (let j = 0; j < res2.data.length; j++) {
                        //  const date = new Date();
                        if (((new Date(res2.data[j].feedbackSentDate)) > (new Date()))) {
                          const ZeroGapData = {
                            emailStatus: 1,
                            externalTokenExpired:1,
                          }
                          console.log(res2.data[j].feedbackSentDate);
                          this.$store
                            .dispatch("external-feedback/patch", [res2.data[j].id, ZeroGapData])
                            .then(res3 => {
                              console.log("external feedback patched", res3);
                            })
                            .catch(err => {
                              console.log("error goal mark complete", err);
                            });
                        }
                      }
                    })
                    .catch(err => {
                      console.log("error goal mark complete", err);
                    });

                })
                .catch(err => {
                  console.log("error goal mark complete", err);
                });
            })
            .catch(err => {
              console.log("error goal mark complete", err);
            });
        }
      },

      ScheduleEmail(data){
        this.confirmScheduleEmail=true;
        this.FeedbackData=data
      },
      confirmresetScheduleEmail(data){
        console.log('dataaaa',data);
        const query={query:{id:data.traineeCompetenciesId}}
        this.$store
          .dispatch("addSkill/findCompetency", query)
          .then(traineeCompetency => {
              this.$store
                .dispatch("userManagement/fetchUser", traineeCompetency.data[0].usersId)
                .then(users => {
                    console.log(users,data);
                    const query={query:{
                        endorsementInviteId:data.id,
                      }}
                    this.$store
                      .dispatch("endorsementInvite/fetchInviteePrgms", query)
                      .then(fetchInviteePrgms => {
                        console.log("invitee data", fetchInviteePrgms);

                        const query1={query:{endorsementInvitePrgmsId:fetchInviteePrgms.data[0].id}}
                        this.$store
                          .dispatch("endorsementInvite/fetchFeeddata", query1)
                          .then(fetchFeeddata => {
                            for (var i=0;i<fetchFeeddata.data.length;i++) {
                              if(((new Date(fetchFeeddata.data[i].feedbackSentDate)) > (new Date()))) {
                                if(traineeCompetency.data[0].competencyId.length<=12) {
                                  const characteristicId = traineeCompetency.data[0].competencyId.split("-")[0];
                                  const competencyId = traineeCompetency.data[0].competencyId.split("-")[1];
                                  console.log(characteristicId, competencyId);
                                  const competencies = this.CCD[characteristicId].competencies;
//                                console.log(competencies);
                                  const currentCompetency = competencies[competencyId];
                                  console.log(currentCompetency);
                                  this.currentCompetency = currentCompetency;
                                  this.InviteSkillName = currentCompetency.comp;
                                }else{
                                  this.InviteSkillName ='';
                                }
                                console.log('skill name',this.InviteSkillName);
                                const  extFeedObj = {
                                  traineeName: users.firstName+' '+users.lastName,
                                  mailType: "followup",
                                  flag:"RescheduleEmail",
                                  inviteeEmail: data.inviteeEmail,
                                  inviteUserName: data.inviteUserName,
                                  skillName:this.InviteSkillName,
                                  trainingDuration: traineeCompetency.data[0].trainingDuration,
                                  endorsementInvitePrgmsId: fetchInviteePrgms.data[0].id,
                                  externalToken:fetchFeeddata.data[i].externalToken,
                                  lang: ((window.$cookies.get('locale') =='es')?'es':'en'),
                                  externalTokenExpired: false,
                                  feedbackSentDate: fetchFeeddata.data[i].feedbackSentDate,
                                  emailStatus:0
                                };
                                console.log(extFeedObj);
                                this.$store
                                  .dispatch("external-feedback/patch", [fetchFeeddata.data[i].id, extFeedObj])
                                  .then(res => {
                                    console.log("email resend data updated", res);
                                  })
                                  .catch(err => {
                                    console.log("email resend data not updated", err);
                                  });
                                console.log(extFeedObj);
                              }
                            }
                            //  this.confirmResetscheduleInvite=false;
                            this.$vs.notify({
                              color: "primary",
                              title: i18n.t('notification.user.traineeList.emailSchedule.reSchedule.success.s1'),
                              text:  i18n.t('notification.user.traineeList.emailSchedule.reSchedule.success.s2')
                            });
                            console.log("feed data",fetchFeeddata);
                            // this.$router.push({ name: "goal-complete" });
                          })
                          .catch(err => {
                            this.$vs.notify({
                              color: "danger",
                              title: i18n.t('notification.user.traineeList.emailSchedule.reSchedule.failed.s1'),
                              text:  i18n.t('notification.user.traineeList.emailSchedule.reSchedule.failed.s2')
                            });
                            console.log("error fetch Feed data ", err);
                          });
                      })
                      .catch(err => {
                        console.log("error goal mark complete", err);
                      });
                  }
                )
                .catch(err => {
                  console.log("users complete", err);
                });
            }
          )
          .catch(err => {
            console.log("users complete", err);
          });
      },
    }

  }
</script>
<style lang="scss">
  .vs-table--not-data {
    padding: 10px;
    text-align: center;
    display: none;
  }
  #data-list-list-view {
    .vs-con-table {

      /*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;

          .vs-table--search-input {
            width: 100%;
          }
        }
      }

      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }

      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;

          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
<style lang="stylus">
  .con-expand-users
    .con-btns-user
      display flex
      padding 10px
      padding-bottom 0px
      align-items center
      justify-content space-between
      .con-userx
        display flex
        align-items center
        justify-content flex-start
    .list-icon
      i
        font-size .9rem !important
</style>
